import { ColumnActionsMode, IColumn, Icon } from "@fluentui/react";
import { NavigateFunction } from "react-router-dom";

import { translateTermSteps } from "../../Terms/utils/translateTermSteps";

import { ColoredLabel } from "@/components/ColoredLabel/ColoredLabel";
import { ClickableDiv } from "@/modules/Contracts/styles";
import { cpfCnpjFormatter } from "@/utils/FormatCPForCNPJ";

export function buildComplementaryDocumentsColumns({
  hasActions,
  navigate
}: {
  hasActions: boolean;
  navigate: NavigateFunction;
}) {
  const columns: IColumn[] = [
    {
      key: "fullName",
      name: "Nome",
      fieldName: "fullName",
      isRowHeader: true,
      minWidth: 200,
      maxWidth: 300,
      isPadded: true,
      onRenderHeader: () => {
        return (
          <div>
            <Icon iconName="Contact" style={{ paddingRight: "5px" }} />
            Nome
          </div>
        );
      },
      onRender: item => {
        const termsPath = `/complementary-documents/${item.id}`;

        return (
          <ClickableDiv onClick={() => navigate(termsPath)} width="auto">
            {item.termDataDraft?.fullName}
          </ClickableDiv>
        );
      }
    },
    {
      key: "contractId",
      name: "Contrato",
      fieldName: "contractId",
      isRowHeader: true,
      minWidth: 50,
      maxWidth: 85,
      isPadded: true,
      onRender: item => {
        return (
          <p
            style={{ margin: 0, cursor: "default", whiteSpace: "break-spaces" }}
            title={item.contractId}
          >
            {item.contractId}
          </p>
        );
      },
      onRenderHeader: () => {
        return (
          <div>
            <Icon iconName="DocumentSet" style={{ paddingRight: "5px" }} />
            Contrato
          </div>
        );
      }
    },
    {
      key: "documentNumber",
      name: "CPF/CNPJ",
      fieldName: "documentNumber",
      isRowHeader: true,
      minWidth: 100,
      maxWidth: 150,
      onRenderHeader: () => {
        return (
          <div>
            <Icon iconName="ContactCard" style={{ paddingRight: "5px" }} />
            CPF/CNPJ
          </div>
        );
      },
      onRender(item) {
        return (
          <p
            style={{ margin: 0, cursor: "default", whiteSpace: "break-spaces" }}
          >
            {cpfCnpjFormatter(item.termDataDraft?.documentNumber)}
          </p>
        );
      },
      isPadded: true
    },
    {
      key: "businessUnitId",
      name: "Unidade de Negócio",
      fieldName: "businessUnit",
      isRowHeader: true,
      minWidth: 200,
      maxWidth: 350,
      isPadded: true,
      onRender: ({ businessUnit }) => {
        const buParent = businessUnit?.parent;
        const names = [
          buParent?.parent?.name,
          buParent?.name,
          businessUnit.name
        ].filter(Boolean);
        const text = names.join(" -> ");

        return (
          <p
            style={{ margin: 0, cursor: "default", whiteSpace: "break-spaces" }}
            title={text}
          >
            {text}
          </p>
        );
      },
      onRenderHeader: () => {
        return (
          <div>
            <Icon iconName="EMI" style={{ paddingRight: "5px" }} />
            Unidade de Negócio
          </div>
        );
      }
    },
    {
      key: "type",
      name: "Tipo",
      minWidth: 160,
      maxWidth: 160,
      fieldName: "type",
      isRowHeader: true,
      isPadded: true,
      isMultiline: true,
      onRender: () => (
        <p style={{ margin: 0, cursor: "default", whiteSpace: "break-spaces" }}>
          Troca de Titularidade
        </p>
      ),
      onRenderHeader: () => {
        return (
          <div>
            <Icon iconName="ContactInfo" style={{ paddingRight: "5px" }} />
            Tipo
          </div>
        );
      }
    },
    {
      key: "currentStep",
      name: "Estado",
      minWidth: 160,
      maxWidth: 160,
      fieldName: "currentStep",
      isRowHeader: true,
      isPadded: true,
      isMultiline: true,
      onRender: item => (
        <ColoredLabel {...translateTermSteps(item.currentStep.internalName)} />
      ),
      onRenderHeader: () => {
        return (
          <div>
            <Icon iconName="ContactInfo" style={{ paddingRight: "5px" }} />
            Status
          </div>
        );
      }
    }
  ];

  if (hasActions) {
    columns.push({
      key: "actions",
      name: "actions",
      fieldName: "actions",
      minWidth: 40,
      maxWidth: 40,
      columnActionsMode: ColumnActionsMode.disabled,
      isIconOnly: true
    });
  }

  return columns;
}
